export { default } from './ChessPieces'
